const TRANSLATIONS = {
  'menu.apps': 'Apps',
  'menu.statistics': 'Statistics',
  'menu.multi-account-apps': 'Statistics for All Accounts',
  'menu.audience-builder': 'Audience Builder',
  'menu.deeplink-generator': 'Deeplink Generator',
  'menu.control-center': 'Automate',
  'menu.settings.account': 'My Account',
  'menu.settings.profile': 'My Profile',
  'menu.settings.san': 'Partner Ad Accounts',
  'menu.data-studio': 'Data Canvas',
  'menu.docs': 'Help Center',
  'label.account': 'Account',
  'label.select-account': 'Select Account',
  'label.logged-in-as': 'Logged in as:',
  'action.logout': 'Logout',
  'menu.new-dashboard': 'Datascape',
  'menu.smart-banners': 'Smart Banners',
};

export const useTranslate = () => (code: keyof typeof TRANSLATIONS) => TRANSLATIONS[code] || code;
